var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSingapore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0108C0 7.17424 7.1635 0.0107422 16 0.0107422C24.8365 0.0107422 32 7.17424 32 16.0108",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7391 8.35851C9.7391 6.02739 11.3774 4.08001 13.5652 3.6022C13.2289 3.52883 12.8801 3.48901 12.5217 3.48901C9.83222 3.48901 7.6521 5.66914 7.6521 8.35858C7.6521 11.048 9.83222 13.2281 12.5217 13.2281C12.88 13.2281 13.2288 13.1883 13.5652 13.1149C11.3774 12.6371 9.7391 10.6897 9.7391 8.35851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.83691L16.3454 4.89973H17.4629L16.5587 5.55666L16.9041 6.61948L16 5.96266L15.0959 6.61948L15.4412 5.55666L14.5371 4.89973H15.6546L16 3.83691Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2891 5.92383L13.6344 6.9867H14.7519L13.8478 7.64358L14.1932 8.70639L13.2891 8.04958L12.3848 8.70639L12.7302 7.64358L11.826 6.9867H12.9436L13.2891 5.92383Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7107 5.92383L19.0561 6.9867H20.1736L19.2694 7.64358L19.6149 8.70639L18.7107 8.04958L17.8066 8.70639L18.1519 7.64358L17.2478 6.9867H18.3653L18.7107 5.92383Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6675 9.0542L18.0129 10.1171H19.1304L18.2263 10.7739L18.5717 11.8368L17.6675 11.1799L16.7634 11.8368L17.1088 10.7739L16.2047 10.1171H17.3221L17.6675 9.0542Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3328 9.0542L14.6781 10.1171H15.7957L14.8916 10.7739L15.237 11.8368L14.3328 11.1799L13.4286 11.8368L13.774 10.7739L12.8699 10.1171H13.9874L14.3328 9.0542Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSingapore);
export default __webpack_public_path__ + "static/media/flag_singapore.cd9b208c870ccaaba9102d24c33c2d93.svg";
export { ForwardRef as ReactComponent };